export const setActiveTenant = (activeTenant) => ({
    type: "SET_ACTIVE_TENANT",
    payload: activeTenant,
  });

export const setPartnerTenants = (partnerTenants) => ({
  type: "SET_PARTNER_TENANTS",
  payload: partnerTenants,
});